import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { track, trackPageView } from './client';
import { setTelemetryContext } from './context';

/** `/kitting-orders?status=x` → `kitting-orders`; the root is `dashboard`. */
export const toPageId = (pathname: string): string =>
  pathname.split('/').filter(Boolean)[0] || 'dashboard';

// Pathname only: search-param changes are filters and deep links, which report themselves.
export function useRouteTelemetry(): void {
  const { pathname } = useLocation();
  const previous = useRef<string | undefined>(undefined);

  useEffect(() => {
    const page = toPageId(pathname);
    setTelemetryContext({ page });
    track('page_viewed', { path: pathname, from: previous.current });
    trackPageView(page, pathname);
    previous.current = pathname;
  }, [pathname]);
}
